export function hoursOfOut(bool) {
    return {
      type: '@HOURS_OF_OUT',
      payload: bool
    };
  }